import { CalRuleDlyProg } from "./calruledlyprog.model"
import { RsncdDlyProg } from "./rsncddlyprog.model"
export class CalendarRule {
  calrule_id: number;
  descr: string;
  passivated: boolean;
  automatic_copy_period: boolean;
  calendarRuleDlyProgs: CalRuleDlyProg[]; // Array of calendar rule daily programs
  rsncdDlyProgs: RsncdDlyProg[]; // Array of calendar rule daily programs
}
